import useTranslation from "next-translate/useTranslation"
import Router from "next/router"
import { useEffect } from "react"
import { connect, ConnectedProps } from "react-redux"
import { Col, Row, Spinner } from "reactstrap"

import { UserRole } from "@api/schema"
import BaseLayout from "@components/BaseLayout"
import ErrorPage from "@components/ErrorPage"
import { AppState } from "@redux/reducer"
import { selectHasRole, selectIsAuthenticated, selectIsAuthInitialized } from "@redux/reducer/auth"
import { Routes } from "@services/routes"

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function withAuth<T>(Component: React.ComponentType<T>, requiredRole?: UserRole | UserRole[]): React.FC<T> {
  const mapStateToProps = (state: AppState) => ({
    isAuthInitialized: selectIsAuthInitialized(state),
    isAuthenticated: selectIsAuthenticated(state),
    hasRequiredRole: requiredRole ? selectHasRole(state, requiredRole) : true
  })

  const connector = connect(mapStateToProps)
  type AuthProps = ConnectedProps<typeof connector>

  const WithAuthWrapper = (props: AuthProps) => {
    // @todo hack: remove all props that should not be passed on to the wrapped component, dispatch cannot be unused -> destructure again
    const { dispatch: { }, isAuthInitialized, isAuthenticated, hasRequiredRole, ...restProps } = props

    // do not move within the if-clause, causes "rendered fewer hooks than expected."
    const { t } = useTranslation("common")

    useEffect(() => {
      if (isAuthInitialized && !isAuthenticated) {
        void Router.push(Routes.Login + "?redirectBack="
          + encodeURIComponent(window.location.pathname + window.location.search + window.location.hash))
      }
    }, [isAuthInitialized])

    if (typeof window === "undefined" || !isAuthInitialized) {
      return <BaseLayout pageTitle={t("page.loading.title")}>
        <Row>
          <Col>
            <Spinner />
          </Col>
        </Row>
      </BaseLayout>
    }

    if (!hasRequiredRole) {
      return <ErrorPage statusCode={403} />
    }

    return <Component {...restProps as T} />
  }

  return connector(WithAuthWrapper)
}
